import { InlineValuePopover } from "@xola/ui-kit";
import clsx from "clsx";
import { SwitchField } from "common";
import { cloneDeep, isNil, set } from "lodash";
import React, { useState } from "react";
import {
    CutoffStrategy,
    CutoffStrategyCopy,
    PriceDecreasePolicy,
    PriceIncreasePolicy,
    ReschedulePreference,
} from "types";
import { TimePickerPopover } from "../../Common/TimePickerPopover";

interface ReschedulePreferenceFieldProps {
    value: ReschedulePreference | null;
    errors?: any;
    onChange: (value: ReschedulePreference | null) => void;
}

export const ReschedulePreferenceField = ({
    value: reschedulePreference,
    errors,
    onChange,
}: ReschedulePreferenceFieldProps) => {
    const isEnabled = !isNil(reschedulePreference);

    const handleChange = (key: string, value: any) => {
        let currentValue;
        if (reschedulePreference) {
            currentValue = cloneDeep(reschedulePreference);
            set(currentValue, key, value);
        }

        onChange(currentValue ?? null);
    };

    const toggleField = (enabled: boolean) => {
        const defaultValue = {
            cutoff: { duration: 0, strategy: CutoffStrategy.ARRIVAL },
            priceChangePolicy: {
                priceIncreasePolicy: PriceIncreasePolicy.PAYMENT_BEFORE_MODIFICATION,
                priceDecreasePolicy: PriceDecreasePolicy.REFUND_DELTA,
            },
        };
        onChange(enabled ? defaultValue : null);
    };

    return (
        <SwitchField isChecked={isEnabled} onChange={toggleField}>
            Permit date and time changes
            {isEnabled ? (
                <span onClick={(e) => e.stopPropagation()}>
                    {reschedulePreference?.cutoff.strategy !== CutoffStrategy.CHECK_IN && (
                        <>
                            <span className="ml-1">up to</span>
                            <TimePickerPopover
                                showArrow
                                value={reschedulePreference?.cutoff.duration ?? 0}
                                classNames={{
                                    text: clsx(errors?.cutoff?.duration ? "!text-danger" : "!text-black"),
                                }}
                                onApply={(value) => handleChange("cutoff.duration", value)}
                            />
                        </>
                    )}
                    <span className="mr-1"> prior to</span>
                    <StrategyPopover
                        value={reschedulePreference?.cutoff.strategy}
                        onChange={(value) => handleChange("cutoff.strategy", value)}
                    />
                    time
                </span>
            ) : null}
        </SwitchField>
    );
};

interface StrategyPopoverProps {
    value: CutoffStrategy;
    onChange: (value: CutoffStrategy) => void;
}

export const StrategyPopover = ({ value, onChange }: StrategyPopoverProps) => {
    const [visible, setVisible] = useState(false);

    const togglePopover = () => setVisible(!visible);

    return (
        <InlineValuePopover
            showArrow
            placement="bottom"
            text={CutoffStrategyCopy[value]?.toLowerCase()}
            isOpen={visible}
            classNames={{
                text: clsx("!border-black !text-black"),
                children: "!p-0",
            }}
            onClick={togglePopover}
            onClickOutside={togglePopover}
        >
            <div className="w-40 divide-y divide-gray-light font-bold">
                <div className="p-4" onClick={() => onChange(CutoffStrategy.ARRIVAL)}>
                    <p>{CutoffStrategyCopy[CutoffStrategy.ARRIVAL]}</p>
                </div>
                <div className="p-4" onClick={() => onChange(CutoffStrategy.CHECK_IN)}>
                    <p>{CutoffStrategyCopy[CutoffStrategy.CHECK_IN]}</p>
                </div>
            </div>
        </InlineValuePopover>
    );
};
